import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 3.85783C10.5003 3.79861 10.489 3.73991 10.4666 3.68509C10.4442 3.63026 10.4112 3.5804 10.3695 3.53836L8.4615 1.6305C8.41945 1.58879 8.36958 1.5558 8.31475 1.53341C8.25993 1.51102 8.20122 1.49967 8.142 1.50001C8.08277 1.49967 8.02407 1.51102 7.96924 1.53341C7.91441 1.5558 7.86454 1.58879 7.8225 1.6305L6.549 2.9039L1.63051 7.82204C1.5888 7.86408 1.5558 7.91394 1.53341 7.96877C1.51102 8.02359 1.49967 8.08229 1.50001 8.14151V10.0494C1.50001 10.1687 1.54742 10.2832 1.63181 10.3675C1.7162 10.4519 1.83066 10.4993 1.95001 10.4993H3.858C3.92097 10.5028 3.98396 10.4929 4.04287 10.4704C4.10179 10.448 4.15532 10.4133 4.2 10.3688L9.0915 5.45071L10.3695 4.19981C10.4106 4.1562 10.444 4.106 10.4685 4.05132C10.4728 4.01545 10.4728 3.97919 10.4685 3.94333C10.4706 3.92238 10.4706 3.90128 10.4685 3.88033L10.5 3.85783ZM3.6735 9.5994H2.40001V8.326L6.8685 3.85783L8.142 5.13124L3.6735 9.5994ZM8.77649 4.49678L7.503 3.22338L8.142 2.58893L9.41099 3.85783L8.77649 4.49678Z",
		fill: "#CCCCDC",
		fillOpacity: .65
	})
});
export { SvgPen as ReactComponent };
